<template>
  <content-loader
    view-box="0 0 374 87"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
  >

    <rect x="98" y="68" rx="1" ry="1" width="135" height="8" /> 
    <rect x="98" y="26" rx="1" ry="1" width="135" height="8" /> 
    <rect x="0" y="39" rx="5" ry="5" width="400" height="1" /> 
    <rect x="253" y="68" rx="1" ry="1" width="60" height="8" /> 
    <rect x="253" y="26" rx="1" ry="1" width="60" height="8" /> 
    <rect x="334" y="26" rx="1" ry="1" width="60" height="8" /> 
    <rect x="0" y="20" rx="5" ry="5" width="400" height="1" /> 
    <rect x="0" y="60" rx="5" ry="5" width="400" height="1" /> 
    <rect x="334" y="47" rx="1" ry="1" width="60" height="8" /> 
    <rect x="0" y="2" rx="5" ry="5" width="400" height="1" /> 
    <rect x="0" y="82" rx="5" ry="5" width="400" height="1" /> 
    <rect x="98" y="8" rx="1" ry="1" width="135" height="8" /> 
    <rect x="253" y="8" rx="1" ry="1" width="60" height="8" /> 
    <rect x="334" y="7" rx="1" ry="1" width="60" height="8" /> 
    <rect x="253" y="47" rx="1" ry="1" width="60" height="8" /> 
    <rect x="334" y="68" rx="1" ry="1" width="60" height="8" /> 
    <rect x="85" y="7" rx="0" ry="0" width="9" height="8" /> 
    <rect x="98" y="47" rx="1" ry="1" width="135" height="8" /> 
    <rect x="85" y="26" rx="0" ry="0" width="9" height="8" /> 
    <rect x="8" y="7" rx="1" ry="1" width="60" height="8" /> 
    <rect x="8" y="26" rx="1" ry="1" width="60" height="8" /> 
    <rect x="85" y="46" rx="0" ry="0" width="9" height="8" /> 
    <rect x="85" y="68" rx="0" ry="0" width="9" height="8" /> 
    <rect x="8" y="47" rx="1" ry="1" width="60" height="8" /> 
    <rect x="8" y="68" rx="1" ry="1" width="60" height="8" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "TableWithFileLoader",
    components: {
        ContentLoader, 
    }
};
</script>
